<template>
  <div class="dashboard-home">
    <DashboardStats />
  </div>
</template>

<script>
import DashboardStats from '../components/DashboardStats.vue'

export default {
  name: 'DashboardHome',
  components: {
    DashboardStats
  }
}
</script>

<style scoped>
.dashboard-home {
  padding: 24px;
}
</style> 